/* global lpTag */
import getUser from '@ynap/analytics/src/user'; // eslint-disable-line monorepo/no-internal-import
import { getCustomerVariables } from './formatData';
import { hideLiveChatButton } from './dom';
import { waitUntil } from './utils';

/**
 * LivePerson events to bind
 * @type {Array}
 */
export const liveChatEvents = [
    // This event is triggered when the engagement has been accepted by a user.
    {
        eventName: 'OFFER_CLICK',
        appName: 'LP_OFFERS',
        func: hideLiveChatButton
    },
    // This event is triggered when an engagement is closed by a user.
    {
        eventName: 'OFFER_DECLINED',
        appName: 'LP_OFFERS',
        func: hideLiveChatButton
    },
    // This event is triggered when an engagement is removed from the DOM (auto or user initiated).
    {
        eventName: 'OFFER_REMOVE',
        appName: 'LP_OFFERS',
        func: hideLiveChatButton
    }
];

/**
 * Starts lpTag and pushes customer info to sdes
 */
export const startLPTag = async (brand, language, env, country) => {
    if (!lpTag) {
        return;
    }

    if (typeof lpTag.start === 'function') {
        lpTag.isDom = true;
        lpTag.start();
    }

    if (!lpTag.section?.length) {
        lpTag.section = [brand, language];
        country && lpTag.section.push(country)
        env && lpTag.section.push(env)

    }

    if (!lpTag?.sdes?.get?.('ctmrinfo')?.length) {
        const userData = await getUser();
        lpTag.sdes = lpTag.sdes || [];
        lpTag.sdes.push(getCustomerVariables(userData));

        if (userData?.attributes?.category?.name === 'EIP') {
            lpTag.section.push('eip');
        }
    }
};

/**
 * Inserts section and SDES info into lpTag
 * User info only needed when going to newPage as calling that method clears all previous SDES
 * @todo: find a way not to call await getUser twice on apps that call pushData right after startLPTag is called.
 * @param {Object} data
 * @param {Array} data.sectionData array containing current page sections
 * @param {Array|Object} data.pageSdes array or object of sdes to push or insert in newPage call
 */
const pushDataToLivePerson = async ({ sectionData, pageSdes, additionalSections = [] } = {}) => {
    window.lpTag = window.lpTag || {};
    const userData = await getUser();
    const isEip = userData?.attributes?.category?.name === 'EIP';

    waitUntil(() => !!lpTag.loaded, 5, 1000)
        .then(result => {
            if (result) {
                lpTag.newPage(window.location.href, {
                    section: isEip ? [...sectionData, ...additionalSections, 'eip'] : [...sectionData, ...additionalSections],
                    sdes: [pageSdes, getCustomerVariables(userData)]
                });
            }
        })
        .catch();
};

export default pushDataToLivePerson;
